import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-change-password-dialog',
    templateUrl: './change-password-dialog.component.html',
    styleUrls: ['./change-password-dialog.component.css'],
    standalone: false
})
export class ChangePasswordDialogComponent {
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  showCurrent = false;
  showNew = false;
  showConfirm = false;
  myform: any;
  submitted = false;
  originalFormValue: any;
  passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,15}$/;
  passwordError: string = '';

  constructor(private dialogRef: MatDialogRef<ChangePasswordDialogComponent>, private dialog: MatDialog, private router: Router, public auth: AuthService,
    private formBuilder: FormBuilder, public toast: ToastrService) { }

  ngOnInit() {
    // this.myform = this.formBuilder.group({
    //   field:[''],
    //   old: ['', [Validators.required,Validators.pattern(/^\S+$/)]],
    //   new: ['', [Validators.required, Validators.minLength(8),Validators.pattern(/^\S+$/)]],
    //   con: ['', [Validators.required,Validators.pattern(/^\S+$/)]]
    // }, { validators: [this.checkPasswords, this.checkNotOldPassword] });
        
    this.myform = this.formBuilder.group({
      field: [''],
      old: ['', [Validators.required]],
      new: ['', [Validators.required, Validators.minLength(8)]],
      con: ['', [Validators.required]]
    }, { validators: [this.checkPasswords, this.checkNotOldPassword] });

    // Store the initial form value
    this.originalFormValue = this.myform.value;
  }


  // checkPasswords(group: FormGroup) {
  //   const pass = group.get('new')?.value;
  //   const confirmPass = group.get('con')?.value;
  //   return pass === confirmPass ? null : { notSame: true };
  // }
  // checkNotOldPassword(group: FormGroup) {
  //   const old = group.get('old')?.value;
  //   const newPass = group.get('new')?.value;
  //   if (old && newPass && old === newPass) {
  //     return { sameAsOld: true }; // error key
  //   }
  //   return null;
  // }

  checkPasswords(group: FormGroup) {
    const pass = (group.get('new')?.value || '').trim();
    const confirmPass = (group.get('con')?.value || '').trim();
    return pass === confirmPass ? null : { notSame: true };
  }

  checkNotOldPassword(group: FormGroup) {
    const old = (group.get('old')?.value || '').trim();
    const newPass = (group.get('new')?.value || '').trim();
    if (old && newPass && old === newPass) {
      return { sameAsOld: true };
    }
    return null;
  }

  onInputTrim(controlName: string) {
    const control = this.myform.get(controlName);
    if (control) {
      control.setValue(control.value.trimStart(), { emitEvent: false });
    }
  }

  toggleVisibility(type: 'current' | 'new' | 'confirm') {
    if (type === 'current') this.showCurrent = !this.showCurrent;
    else if (type === 'new') this.showNew = !this.showNew;
    else if (type === 'confirm') this.showConfirm = !this.showConfirm;
  }

  // save() {
  //   if (this.newPassword.length < 8) {
  //     alert('Password must be at least 8 characters');
  //     return;
  //   }
  //   if (this.newPassword !== this.confirmPassword) {
  //     alert('Passwords do not match');
  //     return;
  //   }
  //   // call API or emit result
  //   //console.log('Password changed!');
  //   this.dialogRef.close();
  // }

  Onsubmit() {
    this.submitted = true;
    console.log('pwdForm', this.myform)
    if (this.myform.invalid) return;
     
   // this.myform.get("field").setValue('password');

    const payload = {
      field: 'password',
      old: this.myform.value.old,
      new: this.myform.value.new
      // Don't send 'con' to the API
    };

    this.auth.update_password(payload).subscribe((res: any) => {
      if(res.error === true) {
        this.toast.error(res.msg);
        //this.toast.error('Invalid Current Password!')
        return
      }
      else{
        this.toast.success(res.msg);
        this.dialogRef.close();
      }
    },
    (error: HttpErrorResponse) => {
      // This block runs for HTTP 4xx or 5xx errors
      const errorMsg = error?.error?.msg || 'Something went wrong.';
      this.toast.error(errorMsg);
    });
  }

  cancel() {
    if (this.myform.dirty && JSON.stringify(this.myform.value) !== JSON.stringify(this.originalFormValue)) {
      this.showConfirmationDialog();
    } else {
      this.dialogRef.close();
    }
  }
    
    showConfirmationDialog(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      height: '200px',
      disableClose: true,
      data: { message: 'Are you sure you want to continue ?' },
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if (result) {
        this.dialogRef.close();
      }
    });
  }

  //prevent space at 1st position
  // preventLeadingSpace(event: KeyboardEvent) {
  //   const input = event.target as HTMLInputElement;
  //   const isFirstChar = input.selectionStart === 0;

  //   // If space is pressed at position 0, prevent it
  //   if (event.key === ' ' && isFirstChar) {
  //     event.preventDefault();
  //   }
  // }
  //prevent space anywhere
  // validateSpace(event: KeyboardEvent) {
  //   if (event.key === ' ') {
  //     event.preventDefault(); // block space entirely
  //   }
  // }
  validateSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const cursorPosition = input.selectionStart ?? 0;

    // Disallow space at the beginning
    if (event.key === ' ' && cursorPosition === 0) {
      event.preventDefault();
      return;
    }

    // Disallow consecutive spaces (two or more)
    if (event.key === ' ' && value[cursorPosition - 1] === ' ') {
      event.preventDefault();
      return;
    }
  }

  checkPassword(event: Event) {
    const input = (event.target as HTMLInputElement).value;

    if (!this.passwordPattern.test(input)) {
      this.passwordError = "Password must be 8-15 characters with at least 1 digit, 1 uppercase, 1 lowercase, and 1 special character";
    } else {
      this.passwordError = '';
    }
  }
  
}
